import classNames from 'classnames';
import * as React from 'react';

import * as styles from './SpecialPromoDesktop.css';

interface ISpecialPromoDesktopProps {
  href: string;
  isPik: boolean;
  logoUrl?: string | null;
  title?: string;

  onClick(): void;
}

export const SpecialPromoDesktop: React.FC<ISpecialPromoDesktopProps> = ({ logoUrl, isPik, onClick, href, title }) => (
  <a data-testid="special-promo-logo" href={href} onClick={onClick} className={styles['link']}>
    {logoUrl && (
      <span
        className={classNames(styles['icon'], isPik && styles['icon-pik'])}
        style={{
          backgroundImage: `url(${logoUrl})`,
        }}
      />
    )}
    {title && <span className={styles['title']}>{title}</span>}
  </a>
);
